import type { LevelDefinition } from "./types";
import { effectiveTargetLengthFor, type Platform } from "@/platform/Platform";

/**
 * PR34: the Campaign gate target a run on `platform` actually has to reach.
 * Mobile Mars/Saturn/Sun: `Math.round(level.targetLength * 0.85)`; every
 * other world, and Desktop everywhere: exactly `level.targetLength`.
 *
 * Pure: never mutates `level` - the shared `LevelRegistry` definitions keep
 * their raw (Desktop/canonical) targets. Floored at `initialLength + 1` so
 * the gate can never be open from the very first step (every current level
 * is far above that anyway). Only for real Campaign levels - Daily/Endless
 * never call this.
 */
export function getEffectiveTargetLength(level: LevelDefinition, platform: Platform): number {
  const effective = effectiveTargetLengthFor(level.worldId, level.targetLength, platform);
  if (effective === level.targetLength) return effective;
  return Math.max(level.initialLength + 1, effective);
}
